import React from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Fade from '@material-ui/core/Fade';
import Typography from '@material-ui/core/Typography';
import logoImg from '../assets/images/MMXLogo_150x150.png'
import Grid from '@material-ui/core/Grid';
import TotalPremium from 'components/quote_sectiions/total_premium';
import FMV from 'components/quote_sectiions/fmv';
import Coverage from 'components/quote_sectiions/coverage';
import Features from 'components/quote_sectiions/featues';
import Premiums from 'components/quote_sectiions/premiums';
import QuoteDropdown from 'components/QouteDropdown';
import { useSelector, useDispatch } from 'react-redux';
import Tooltip from '@material-ui/core/Tooltip';
import _ from 'lodash'
import { getPAPremium } from 'utils/utils';

const useStyles = makeStyles({
    root: {
      width: 340,
      maxWidth: 340
    },
    providerImgContainer: {
        backdropFilter: 'transparent',
        paddingLeft: 20,
        textAlign: 'center',
        position: 'relative'
    },
    providerImg: {
        width: 145,
        height: 110,
        display: 'inline-block',
        objectFit: 'contain'
    },
    cardContent: {
        padding: 0,
        '& .MuiCardContent-root:last-child': {
            paddingBottom: '0 !important'
        }
    },
    currentProvider: {
        textAlign: 'center',
        padding: '10px',
        position: 'absolute',
        width: '88%',
        background: '#383737',
        color: '#ffffff',
        top: '-29px'
    },
    notCurrentProvider: {
        textAlign: 'center',
        padding: '0 10px',
        position: 'absolute',
        width: '88%',
        background: 'transparent',
        top: 7
    },
    colorCode: {
        height: 5,
        width: '100%',
        display: 'inline-block',
        position: 'absolute',
        top: 0,
        left: 0,
        borderRadius: 0,
        cursor: 'pointer !important'
    },
    tooltip: {
        fontSize: 16,
        backgroundColor: '#ffffff',
        maxWidth: 220,
        color: 'rgba(0, 0, 0, 0.87)',
        position: 'relative',
        border: '2px solid'
    },
    tooltipArrow: {
        color: '#b3b3b3',
        border: '#f2f2f2'
    },
    toolTipInner: {
        backgroundColor: '#ffffff'
    }
});

export const getPricingDetails = (data) => {

    const car_insurance = data.car_insurance[0];
    const product_features = car_insurance.product_features
    const prices = data.prices;
    const product_name = data.product_name;
    const provider_id = data.provider_id;
    const deductible = Math.round(data.deductible / 100);
    const act_of_nature_coverage = (data.prices.act_of_nature != null) ? data.prices.act_of_nature.coverage / 100 : 0;
    const act_of_nature_price = (data.prices.act_of_nature != null) ? data.prices.act_of_nature.price / 100 : 0;
    const bodily_injury = data.prices.bodily_injury;
    const personal_accident = data.prices.personal_accident;
    const property_damage = data.prices.property_damage;
    const own_damage_theft_coverage = data.prices.own_damage_theft.coverage / 100;
    const own_damage_theft_price = data.prices.own_damage_theft.price / 100;
    const bodily_injury_coverage = data.prices.bodily_injury.coverage / 100;
    const bodily_injury_price = data.prices.bodily_injury.price / 100;
    const property_damage_coverage = property_damage.coverage / 100;
    const property_damage_price = property_damage.price / 100;
    const personal_accident_coverage = data.prices.personal_accident.coverage;
    const personal_accident_price = data.prices.personal_accident.price / 100;
    const net_premium_final = act_of_nature_price + own_damage_theft_price + bodily_injury_price + property_damage_price + personal_accident_price; 
    const rates = (car_insurance.rates.length > 0) ? car_insurance.rates[0] : 0;
    const document_stamp_tax = rates.document_stamp_tax;
    const document_stamp_tax_price = Math.round( (rates.document_stamp_tax / 100) * net_premium_final );
    const local_government_tax = rates.local_government_tax;
    const local_government_tax_price = Math.round( (rates.local_government_tax / 100) * net_premium_final );
    // const vat_price = Math.round( (rates.vat / 100) * net_premium_final );
    const vat_price = data.taxes ? data.taxes.vat ? Math.round(data.taxes.vat.price / 100) : 0 : 0;
    const car_type = data.car_type;
    const number_of_seats = data.number_of_seats;
    const vehicle_type = data.vehicle_type;
    const is_accredited = data.is_accredited;

    const ratesMain = car_insurance.rates ? car_insurance.rates[0] : null;
    const ratesArray = ratesMain ? ratesMain.rates ? ratesMain.rates : null : null;

    // GET Personal Acc premium with provider logic. personal_accident_price atm always return 0;
    const personal_accident_premium = getPAPremium( ratesArray, data['car_type'], data['vehicle_type'], data['product_name'], personal_accident ? personal_accident.coverage : null );
    // const total_premium = Math.round( net_premium_final + parseFloat(document_stamp_tax_price) + parseFloat(local_government_tax_price) + parseFloat(vat_price) + personal_accident_premium );
    const total_premium = Math.round(data.total_premium / 100);

    const result = {
        car_insurance,
        product_features,
        prices,
        product_name,
        provider_id,
        deductible,
        act_of_nature_coverage,
        act_of_nature_price,
        bodily_injury,
        personal_accident,
        property_damage,
        own_damage_theft_coverage,
        own_damage_theft_price,
        bodily_injury_coverage,
        bodily_injury_price,
        property_damage_coverage,
        property_damage_price,
        personal_accident_coverage,
        personal_accident_price,
        personal_accident_premium,
        net_premium_final,
        rates,
        ratesArray,
        document_stamp_tax,
        document_stamp_tax_price,
        local_government_tax,
        local_government_tax_price,
        vat_price,
        total_premium,
        car_type,
        number_of_seats,
        vehicle_type,
        is_accredited
    }
    return result;
}

export const ColorCodeToolTip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: '#ffffff',
      padding: '30px 15px',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: theme.typography.pxToRem(18),
      border: '2px solid',
      borderColor: props => props.color
    },
}))(Tooltip);

function Quote(props) {
    const { data, index, colorTheme } = props;
    const quoteDataTable = getPricingDetails(data)
    const classes = useStyles();
    const quoteData = data.car_insurance;
    const gp = quoteData[0].general_product[0]
    const dispatch = useDispatch();
    const states = useSelector(state => {
        return state.globalStates
    })
    
    const providerOptions = props.quotes.filter( quote => quote.provider_id !== data.provider_id );

    const renderCurrentProviderText = () => {
        const accreditation = quoteDataTable.is_accredited.accreditation;
        const color = quoteDataTable.is_accredited.color;
        const desc = quoteDataTable.is_accredited.accreditation_desc;
        return(
            <div>
                <Fade in={ states.provider === quoteDataTable.product_name }>
                <div>
                { 
                    states.provider === quoteDataTable.product_name ? 
                    <div className={ classes.currentProvider }>
                        <ColorCodeToolTip
                            classes={classes.tooltipArrow}
                            color={ color }
                            arrow
                            placement="top-start"
                            title={
                            <React.Fragment>
                                <div className={ classes.toolTipInner }>
                                    <span style={{ fontWeight: 700 }}>{ accreditation }</span> - <span>{ desc }</span>
                                </div>
                            </React.Fragment>
                            }
                        >
                            <span style={{ background: color }} className={ classes.colorCode }></span>
                        </ColorCodeToolTip>
                        <span>Current Provider</span>
                    </div> : null
                }
                </div>
            </Fade>
            <Fade in={ states.provider !== quoteDataTable.product_name }>
            <div>
                <div className={ classes.notCurrentProvider }>
                    <ColorCodeToolTip
                        classes={{ arrow: classes.tooltipArrow }}
                        color={ color }
                        arrow
                        placement="top-start"
                        title={
                        <React.Fragment>
                            <div className={ classes.toolTipInner }>
                                <span style={{ fontWeight: 700 }}>{ accreditation }</span> - <span>{ desc }</span>
                            </div>
                        </React.Fragment>
                        }
                    >
                        <span style={{ background: color }} className={ classes.colorCode }></span>
                    </ColorCodeToolTip>
                </div>
            </div>
            </Fade>
            </div>
        )
    }

    return(
        <Grid item style={{ position: 'relative' }}>
            { renderCurrentProviderText() }
            <Card className={classes.root}>
                <div className={ classes.providerImgContainer }>
                    <CardMedia
                        className={ classes.providerImg }
                        component="img"
                        alt={ gp.image_alt_text }
                        image={ gp.image.url ? gp.image.url : logoImg }
                        title={ gp.provider.provider_name }
                    />
                    <QuoteDropdown providers={ providerOptions } index={ index }/>
                </div>
                <CardContent classes={{ root: classes.cardContent }}>

                    <TotalPremium premium={ quoteDataTable.total_premium } background={ colorTheme }/>
                    <FMV/>
                    <Coverage quoteDataTable={ quoteDataTable } color={ colorTheme }/>
                    <Features quoteDataTable={ quoteDataTable } color={ colorTheme }/>
                    <Premiums quoteDataTable={ quoteDataTable } color={ colorTheme }/>
                    <TotalPremium premium={ quoteDataTable.total_premium } background={ colorTheme } isBottomPremium={ true }/>

                </CardContent>
            </Card>
        </Grid>
    )
}

export default React.memo(Quote);